import axios from "axios";
const BASE_URL = `${process.env.REACT_APP_API_URL}/api/2.0/integrations`;

export const integrationsApi = {
    fetchIntegrations: async (): Promise<any> => {
    const response = await axios.get(
      `${BASE_URL}`,
    );
    return response.data;
  },
}